import { Navigate, Route, generatePath } from 'react-router-dom';
import { FEEDBACK } from '@hotjar/webapp/constants/routes';
import { NoInterfaceNgApp } from '@hotjar/webapp-routing';

export const FeedbackRoutes = (currentSiteId: string | null): JSX.Element | null => {
  if (currentSiteId === null) return null;
  return (
    <>
      <Route
        path={FEEDBACK.LIST.path}
        element={
          <Navigate
            replace
            to={generatePath(FEEDBACK.RESPONSES_DEFAULT.path, {
              siteId: currentSiteId,
            })}
          />
        }
      />

      <Route path={FEEDBACK.CREATE_BASE.path} element={<NoInterfaceNgApp />} />
      <Route path={FEEDBACK.CREATE.path} element={<NoInterfaceNgApp />} />

      <Route path={FEEDBACK.EDIT.path} element={<NoInterfaceNgApp />} />
      <Route path={FEEDBACK.EDIT_BASE.path} element={<NoInterfaceNgApp />} />
    </>
  );
};
